/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 22
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WorkspaceMemberDepartmentCode
 */
export interface WorkspaceMemberDepartmentCode {
    /**
     * The email address of the workspace member.
     * @type {string}
     * @memberof WorkspaceMemberDepartmentCode
     */
    email: string;
    /**
     * The department code of the workspace member
     * @type {string}
     * @memberof WorkspaceMemberDepartmentCode
     */
    departmentCode: string;
}

export function WorkspaceMemberDepartmentCodeFromJSON(json: any): WorkspaceMemberDepartmentCode {
    return WorkspaceMemberDepartmentCodeFromJSONTyped(json, false);
}

export function WorkspaceMemberDepartmentCodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkspaceMemberDepartmentCode {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': json['email'],
        'departmentCode': json['departmentCode'],
    };
}

export function WorkspaceMemberDepartmentCodeToJSON(value?: WorkspaceMemberDepartmentCode | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'departmentCode': value.departmentCode,
    };
}

